import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import './ContactUs.css';
import imageFashion from './assets/images/sanfrancisco-contact-2.jpg';
import imageIT from './assets/images/NewYork-contact-1.jpg';
import imageConsumer from './assets/images/london-f-e1557154934506-150x150-1-150x150.jpg';
import imageFashion1 from './assets/images/Contact-Us-Page-Singapore.jpg';
import imageIT1 from './assets/images/mumbai.jpg';
import imageConsumer1 from './assets/images/SILICON-VALLEY-F-550x550-1.jpg';
import last  from './assets/images/ContactTab-Web-1.png';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';
import catpcha  from './assets/images/recaptcha-logo.jpeg';



const ContactUs = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const API_URL = 'https://naturativ.org/send-email';
  
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "Contact Us – Bay Capital Advisors";
    
    // Find and update the favicon
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = logo; // Use your logo as favicon
    
    return () => {
      // Reset title when component unmounts if needed
      document.title = "Bay Capital Advisors";
    };
  }, []);
                
                  const toggleMobileMenu = () => {
                    setIsMobileMenuOpen(!isMobileMenuOpen);
                  };
                
                  const closeMobileMenu = () => {
                    setIsMobileMenuOpen(false);
                  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: ''
  });

  const [isCaptchaChecked, setIsCaptchaChecked] = useState(false);
  const [formStatus, setFormStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isCaptchaChecked) {
      setFormStatus('Please verify that you are not a robot');
      return;
    }
    
  
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
        credentials: 'include' // Only if using cookies/sessions
      });
      
      if (response.ok) {
        setFormStatus('Message sent successfully!');
        setFormData({ name: '', email: '', phone: '', website: '', message: '' });
        setIsCaptchaChecked(false);
      } else {
        setFormStatus('Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setFormStatus('An error occurred. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  
  return (
    <div className="contact-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
      <section class="hero8">
      <div class="blue-overlay"></div>
    
    <header class="header8">
    <NavBar />
  </header>
      <header className="terms-of-service-header">
        
          
      
      </header>
      </section>

      {/* Contact Form Section */}
      <div className="form-section">
  <h1 className="help-heading">HOW CAN WE HELP?</h1>
  <p className="sub-heading">
    Want to Accelerate your business with growth capital and strategic expansion?
  </p>
  <p className="sub-text">
    Send us a message and let's get the conversation started.
  </p>

  {/* Conditionally render form or success message */}
  {formStatus === 'Message sent successfully!' ? (
    <div className="success-message">
      
      <p>Thanks for contacting us! We will be in touch with you shortly.</p>
    </div>
  ) : (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group">
        <label htmlFor="name"></label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          className="input-name"
          placeholder="Your Name"
        />
      </div>
      <div className="form-group">
        <label htmlFor="email"></label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="input-email"
          placeholder="Email"
        />
      </div>
      <div className="form-group">
        <label htmlFor="phone"></label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          className="input-phone"
          placeholder="Phone Number"
        />
      </div>
      <div className="form-group">
        <label htmlFor="phone"></label>
        <input
          type="website"
          id="website"
          name="website"
          value={formData.website}
          onChange={handleChange}
          required
          className="input-website"
          placeholder="Website"
        />
      </div>
      <div className="form-group">
        <label htmlFor="message"></label>
        <textarea
          id="message"
          name="message"
          rows="5"
          value={formData.message}
          onChange={handleChange}
          required
          className="input-message"
          placeholder="How can we help"
        ></textarea>
      </div>
      <div className="recaptcha-wrapper" onClick={() => setIsCaptchaChecked(!isCaptchaChecked)}>
          <div className="recaptcha-left">
            <div className={`recaptcha-box ${isCaptchaChecked ? 'checked' : ''}`}>
              {isCaptchaChecked && (
                <svg className="check-icon" viewBox="0 0 24 24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              )}
            </div>
            <span className="recaptcha-label">I'm not a robot</span>
          </div>
          <div className="recaptcha-right">
          <img src={catpcha} alt="catpcha" className="recaptcha-image" />
            <div className="recaptcha-logo">reCAPTCHA</div>
            <div className="recaptcha-terms">Privacy - Terms</div>
          </div>
        </div>
                
        
        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? 'SENDING...' : 'SUBMIT'}
        </button>
        
        {formStatus && (
          <p className={`form-status ${formStatus.includes('verify') ? 'error' : ''}`}>
            {formStatus}
          </p>
        )}
    </form>
  )}

  
</div>


      {/* Locations Section */}
      <div className="locations-section">
        <h2 className="location-heading">Locations</h2>
        

        <div className="contact-news-images">
                <div className="contact-new-card">
                    <img src={imageFashion} alt="Fashion & Retail" className="contact-new-image" />
                    <h3 className="location-title">San Francisco</h3>
                    <p className="location-address">One Embarcadero Center</p>
                    <p className="location-address">Suite 500</p>
                    <p className="location-city">San Francisco, CA 94111</p>
                </div>
                <div className="contact-new-card">
                    <img src={imageIT} alt="IT Services" className="contact-new-image" />
                    <h3 className="location-title">New York</h3>
                    <p className="location-address">300 Park Avenue</p>
                    <p className="location-address">17th Floor</p>
                    <p className="location-city">New York, NY 10022</p>
                </div>
                <div className="contact-new-card">
                    <img src={imageConsumer} alt="Consumer Products" className="contact-new-image" />
                    <h3 className="location-title">United Kingdom</h3>
                    <p className="location-address">90 Long Acre</p>
                    <p className="location-address">Covent Garden</p>
                    <p className="location-city">London, England WC2E 9RZ</p>
                </div>

                <div className="contact-new-card">
                    <img src={imageFashion1} alt="Fashion & Retail" className="contact-new-image" />
                    <h3 className="location-title">Singapore</h3>
                    <p className="location-address">1 Raffles Place Tower 2</p>
                    <p className="location-address"> Level 19</p>
                    <p className="location-city">Singapore 048616</p>
                </div>
                <div className="contact-new-card">
                    <img src={imageIT1} alt="IT Services" className="contact-new-image" />
                    <h3 className="location-title">India</h3>
                    <p className="location-address">Steer Advisory Services Pvt Ltd.</p>
                    <p className="location-city">817 C Wing, One BKC – Bandra East</p>
                    <p className="location-city">Mumbai 400051</p>
                </div>
                <div className="contact-new-card">
                    <img src={imageConsumer1} alt="Consumer Products" className="contact-new-image" />
                    <h3 className="location-title">Mailing Address</h3>
                    <p className="location-address">BAY CAPITAL ADVISORS, INC.</p>
                    <p className="location-city">PO BOX 4127</p>
                    <p className="location-city"> Menlo Park, CA 94026</p>
                </div>
        </div>
      </div>
      <img src={last} alt="Consumer Products" className="contact-new-image2" />
      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
  );
};

export default ContactUs;
